import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Typography,
} from '@mui/material'
import {
  ElectricalEngineeringIcon,
  MechanicalEngineeringIcon,
  StructuralEngineeringIcon,
  PlusSignIcon,
} from '../Svgs'
import { AssignDisciplineNames } from '../../models/Review'
import { getCategoryColor } from '../../utils/ComponentsUtil'
import { getRandomColor } from '../../utils/Common'

interface EngineersListItemRowProps {
  engineer: {
    name: string
    location: string
    phoneNumber: string
    email: string
    projects: string[]
  }
  showDetailedInfo?: boolean
}

const EngineersListItemRowComponent: React.FC<EngineersListItemRowProps> = ({
  engineer,
  showDetailedInfo = true,
}) => {
  const initials = engineer
    ? engineer.name
        .split(' ')
        .map((item) => item.charAt(0))
        .join('')
        .toUpperCase()
    : ''

  return (
    <Grid container width='100%'>
      <Grid size={6} display='flex'>
        <Box width='45%' display='flex' gap='1rem' alignItems='center'>
          <Box
            sx={{
              width: '2rem',
              height: '2rem',
              borderRadius: '2px',
              background: getRandomColor(),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                color: '#fff',
                fontSize: '0.88rem',
                textAlign: 'center',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              {initials}
            </Typography>
          </Box>
          <Typography
            sx={{
              color: '#04002E',
              fontSize: '0.88rem',
              fontWeight: 500,
              lineHeight: 'normal',
            }}
          >
            {engineer.name}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box
          width='55%'
          sx={{
            display: 'flex',
            alignItems: 'center',
            ml: '4rem',
          }}
        >
          <Typography
            sx={{
              color: '#878787',
              fontSize: '0.82rem',
              lineHeight: 'normal',
            }}
          >
            {engineer.location}
          </Typography>
        </Box>
      </Grid>
      <Grid size={6} display='flex' justifyContent='center'>
        {showDetailedInfo && (
          <Box
            gap='0.75rem'
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                borderRadius: '4px',
                background: '#E4E4E4',
                height: '1.5rem',
                width: '5rem',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  color: '#797979',
                  fontSize: '0.64rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                {engineer.phoneNumber}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                borderRadius: '4px',
                background: '#E4E4E4',
                height: '1.5rem',
                width: '12rem',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  color: '#797979',
                  fontSize: '0.64rem',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}
              >
                {engineer.email}
              </Typography>
            </Box>
            <Box
              gap='0.35rem'
              sx={{
                display: 'flex',
                height: '100%',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconButton
                disableRipple
                sx={{
                  borderRadius: '0.25rem',
                  border: `1px solid ${getCategoryColor(AssignDisciplineNames.Structural)}`,
                  padding: 0,
                  width: '1.5rem',
                  height: '1.5rem',
                }}
              >
                <StructuralEngineeringIcon
                  color={getCategoryColor(AssignDisciplineNames.Structural)}
                />
              </IconButton>
              <IconButton
                disableRipple
                sx={{
                  borderRadius: '0.25rem',
                  border: `1px solid ${getCategoryColor(AssignDisciplineNames.Electrical)}`,
                  padding: 0,
                  width: '1.5rem',
                  height: '1.5rem',
                }}
              >
                <ElectricalEngineeringIcon
                  color={getCategoryColor(AssignDisciplineNames.Electrical)}
                />
              </IconButton>
              <IconButton
                disableRipple
                sx={{
                  borderRadius: '0.25rem',
                  border: '1px solid #878787',
                  padding: 0,
                  width: '1.5rem',
                  height: '1.5rem',
                }}
              >
                <PlusSignIcon color='#878787' />
              </IconButton>
            </Box>
            <Button
              variant='outlined'
              sx={{
                textTransform: 'capitalize',
                fontSize: '0.64rem',
                borderRadius: '4px',
                background: 'transparent',
                border: '1px solid #56003D',
                color: '#56003D',
                height: '1.5rem',
              }}
            >
              Reassign
            </Button>
          </Box>
        )}
      </Grid>
    </Grid>
  )
}

export default EngineersListItemRowComponent
